'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _ow = require('ow');

var _ow2 = _interopRequireDefault(_ow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (key, value, tree) {
	(0, _ow2.default)(key, _ow2.default.string.nonEmpty);
	(0, _ow2.default)(key, _ow2.default.any(_ow2.default.string.equals('linkFriendlyName'), _ow2.default.string.equals('categoryId')));
	(0, _ow2.default)(value, _ow2.default.any(_ow2.default.string.nonEmpty, _ow2.default.number.greaterThan(-1)));
	(0, _ow2.default)(tree, _ow2.default.object.nonEmpty);
	(0, _ow2.default)(tree, _ow2.default.object.hasKeys('children'));

	var foundNode = { children: [] };

	tree.children.some(function iterateChildren(node) {
		if (node[key] === value) {
			foundNode = node;
			return true;
		}

		return Array.isArray(node.children) && node.children.some(iterateChildren);
	});

	return foundNode;
};